import { IdToken } from '@auth0/auth0-spa-js'
import dayjs, { Dayjs } from 'dayjs'
import React, { createContext, FC, useState } from 'react'
import { ActiveContract, Contract, Snack } from '../utils/models'

export enum Period {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Year = 'Year',
}

interface IDataContext {
  contracts: Contract[]
  activeContract: ActiveContract | null
  error: Snack
  period: Period
  startDate: Dayjs
  endDate: Dayjs
  token: IdToken | undefined
  setContracts: React.Dispatch<React.SetStateAction<Contract[]>>
  setActiveContract: React.Dispatch<React.SetStateAction<ActiveContract | null>>
  setError: (T: Snack) => void
  setPeriod: React.Dispatch<React.SetStateAction<Period>>
  setStartDate: React.Dispatch<React.SetStateAction<Dayjs>>
  setEndDate: React.Dispatch<React.SetStateAction<Dayjs>>
  restartDate: () => void
  setToken: React.Dispatch<React.SetStateAction<IdToken | undefined>>
}

export const init: IDataContext = {
  contracts: [],
  activeContract: null,
  error: { isError: false, errorMessage: 'string', type: 'error' },
  period: Period.Month,
  startDate: dayjs().subtract(1, 'month'),
  endDate: dayjs(),
  token: undefined,
  setContracts: () => null,
  setActiveContract: () => null,
  setError: ({}) => null,
  restartDate: () => null,
  setPeriod: () => null,
  setStartDate: () => null,
  setEndDate: () => null,
  setToken: () => null,
}

export const DataContext = createContext<IDataContext>(init)

const DataContextProvider: FC = ({ children }) => {
  const [contracts, setContracts] = useState<Contract[]>([])
  const [activeContract, setActiveContract] = useState<ActiveContract | null>(null)
  const [error, setError] = useState<Snack>({
    isError: false,
    errorMessage: '',
  })
  const [period, setPeriod] = useState(Period.Month)
  const [startDate, setStartDate] = useState(dayjs().subtract(1, 'month'))
  const [endDate, setEndDate] = useState(dayjs())
  const [token, setToken] = useState<IdToken | undefined>(undefined)

  const restartDate = () => {
    setStartDate(dayjs().subtract(1, period))
    setEndDate(dayjs())
  }

  return (
    <DataContext.Provider
      value={{
        contracts,
        setContracts,
        activeContract,
        setActiveContract,
        error,
        setError,
        period,
        setPeriod,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        restartDate,
        token,
        setToken,
      }}
    >
      {children}
    </DataContext.Provider>
  )
}

export default DataContextProvider
